import { Loader, ModalGeneric } from 'ypf-pas-general-ui-components';
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';

import useToast from '../../hooks/useToast';
import {
  getImputationObjectsMSDSVE,
  getImputationObjectsSDSVE
} from '../../services/serviceRequest';
import { getImputationObjectsDetails } from '../../services/certificationsMaster';
import './ImputationObjectModal.scss';
import { formatAmountDateBack } from '../../utils/formatUtils';

const ImputationObjectModal = ({
  show,
  onHide,
  imputationObject,
  requestNumber,
  titleUbication,
  monthlyRequest,
  dateInit,
  dateEnd,
  idSolicitud,
  proveedor,
  idUbicacion,
  fromPteAuthorization,
  assignmentType
}) => {
  const [loading, setLoading] = useState(false);
  const [dataOI, setDataOI] = useState(null);
  const [hasUbications, setHasUbications] = useState(false);
  const { setNewToast } = useToast();

  const imputationObjectAdapter = (io) =>
    io?.map((obj) => ({
      posLine: `P${obj.posicion}-L${obj.linea}`,
      objectImputation: obj.objetosImputacion
    }));

  const getImputationObjects = async () => {
    try {
      setLoading(true);
      const resp = monthlyRequest
        ? await getImputationObjectsMSDSVE({
            id: idSolicitud,
            idLocation: idUbicacion,
            dateInit: formatAmountDateBack(dateInit),
            dateEnd: formatAmountDateBack(dateEnd)
          })
        : await getImputationObjectsSDSVE({
            id: idSolicitud,
            dateInit: formatAmountDateBack(dateInit),
            dateEnd: formatAmountDateBack(dateEnd)
          });

      setDataOI(imputationObjectAdapter(resp));
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error?.message || 'No pudimos procesar la solicitud, intente nuevamente.'
      });
    } finally {
      setLoading(false);
    }
  };

  const getOIDetails = async () => {
    setLoading(true);
    try {
      const bodyPost = {
        idSolicitud,
        tipoAsignacionEnum: assignmentType?.id,
        fechaDesde: dateInit,
        fechaHasta: dateEnd,
        ubicacionNombre: titleUbication
      };

      const response = await getImputationObjectsDetails(bodyPost);
      const IOAdapterMsds = (ubications) =>
        ubications.map((ubi) => ({
          nombre: ubi.nombre,
          posLines: ubi?.posicionesLineasImputaciones?.map((obj) => ({
            posLine: `P${obj.posicion}-L${obj.linea}`,
            objectImputation: obj.objetosImputacion
          }))
        }));

      const adapter = !response?.ubicaciones
        ? imputationObjectAdapter(response?.posicionesLineas)
        : IOAdapterMsds(response.ubicaciones);

      setHasUbications(!!response?.ubicaciones);
      setDataOI(adapter);
    } catch (e) {
      setNewToast({
        type: 'ERROR',
        message: e.message ?? 'No se pudo obtener los archivos para descargar.'
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show && !fromPteAuthorization) getImputationObjects();
    if (show && fromPteAuthorization) getOIDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  return (
    <ModalGeneric
      backdrop="static"
      infoModal
      onHide={onHide}
      primaryAction={onHide}
      primaryActionLabel="Salir"
      show={show}
      size="xl"
      title={`Listar tipo y objeto de imputación - ${titleUbication}`}
    >
      <Row className="div-title">
        <Col className="col-first-title">
          <span className="span-title">{proveedor} </span>
          <span className="span-title">{requestNumber}</span>
        </Col>
        {!hasUbications && (
          <Col className="col-second-title">
            <span style={{ fontWeight: '500', color: 'black' }}> {'Tipo y objeto '}</span>{' '}
            <span className="span-title">{imputationObject}</span>
          </Col>
        )}
      </Row>
      {loading && <Loader show text="CARGANDO ..." />}

      {dataOI && !hasUbications && (
        <div className="div-table narrow-scrollbar scroll-track-margin">
          {dataOI.map((obj, index) => (
            <>
              {index > 0 && <hr />}
              <Row
                key={`${obj.posLine} - ${index.toString()}`}
                style={{
                  display: 'flex',
                  flexWrap: 'nowrap',
                  justifyContent: 'flex-start',
                  padding: '5px'
                }}
              >
                <Col style={{ flex: '1 1 auto', flexBasis: '100px' }}>
                  <span>{obj.posLine}</span>
                </Col>
                <Col style={{ flex: '1 1 auto', fontWeight: '500' }}>
                  <span style={{ width: '100%', wordBreak: 'break-word' }}>
                    {obj.objectImputation?.map((item, indexObj) => (
                      <>
                        {indexObj > 0 && (
                          <span style={{ margin: '0 5px', fontSize: '1.2rem' }}> | </span>
                        )}
                        {item}
                      </>
                    ))}
                  </span>
                </Col>
              </Row>
            </>
          ))}
        </div>
      )}
      {dataOI && hasUbications && (
        <>
          {dataOI.map((ubi, index) => (
            <>
              <Row className="my-4 mx-2">
                <Col>
                  <span className="fw-bolder">{ubi?.nombre}</span>
                </Col>
                <Col className="text-end">
                  <span className="fw-normal">Tipo y objecto por defecto: </span>
                  <span className="fw-bolder">{ubi?.objetoImputacion}</span>
                </Col>
              </Row>
              <div
                className="div-table narrow-scrollbar scroll-track-margin"
                key={`${ubi.nombre} - ${index.toString()}`}
              >
                {ubi?.posLines?.map((ubication, i) => (
                  <>
                    {i > 0 && <hr />}
                    <Row
                      key={`${ubication.posLine} - ${index.toString()}`}
                      style={{
                        display: 'flex',
                        flexWrap: 'nowrap',
                        justifyContent: 'flex-start',
                        padding: '5px'
                      }}
                    >
                      <Col style={{ flex: '1 1 auto', flexBasis: '100px' }}>
                        <span>{ubication.posLine}</span>
                      </Col>
                      <Col style={{ flex: '1 1 auto', fontWeight: '500' }}>
                        <span style={{ width: '100%', wordBreak: 'break-word' }}>
                          {ubication.objectImputation?.map((item, indexObj) => (
                            <>
                              {indexObj > 0 && (
                                <span style={{ margin: '0 5px', fontSize: '1.2rem' }}> | </span>
                              )}
                              {item}
                            </>
                          ))}
                        </span>
                      </Col>
                    </Row>
                  </>
                ))}
              </div>
            </>
          ))}
        </>
      )}
    </ModalGeneric>
  );
};

export default ImputationObjectModal;

ImputationObjectModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  imputationObject: PropTypes.string.isRequired,
  requestNumber: PropTypes.string.isRequired,
  titleUbication: PropTypes.string.isRequired,
  monthlyRequest: PropTypes.bool.isRequired,
  dateInit: PropTypes.string.isRequired,
  dateEnd: PropTypes.string.isRequired,
  idSolicitud: PropTypes.number.isRequired,
  proveedor: PropTypes.string.isRequired,
  idUbicacion: PropTypes.number.isRequired,
  fromPteAuthorization: PropTypes.bool,
  assignmentType: PropTypes.oneOfType({})
};

ImputationObjectModal.defaultProps = {
  fromPteAuthorization: false,
  assignmentType: {}
};
